export const LOGIN_DATA = "LOGIN_DATA";
export const LOGIN_DATA_SUCCESS = "LOGIN_DATA_SUCCESS";
export const LOGIN_DATA_FAIL = "LOGIN_DATA_FAIL";
export const LOGIN_DATA_CLEAR = "LOGIN_DATA_CLEAR";
export const LOGIN_DATA_OVERRIDE = "LOGIN_DATA_OVERRIDE";

export const SIGNUP_DATA = "SIGNUP_DATA";
export const SIGNUP_DATA_SUCCESS = "SIGNUP_DATA_SUCCESS";
export const SIGNUP_DATA_FAIL = "SIGNUP_DATA_FAIL";
export const SIGNUP_DATA_CLEAR = "SIGNUP_DATA_CLEAR";


export const VERIFY_EMAIL_INIT = "VERIFY_EMAIL_INIT";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAIL = "VERIFY_EMAIL_FAIL";

export const OTP_VERIFY_INIT = "OTP_VERIFY_INIT";
export const OTP_VERIFY_SUCCESS = "OTP_VERIFY_SUCCESS";
export const OTP_VERIFY_FAIL = "OTP_VERIFY_FAIL";

export const RESET_PASSWORD_INIT = "RESET_PASSWORD_INIT";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const TOASTMESSAGE_DATA = "TOASTMESSAGE_DATA";
export const TOASTMESSAGE_DATA_CLEAR = "TOASTMESSAGE_DATA_CLEAR";


